export interface Testimonial {
  id: number;
  name: string;
  role: string;
  content: string;
  rating: number;
}

export const testimonials: Testimonial[] = [
  {
    id: 1,
    name: '松冈锭司',
    role: '知名导演',
    content: '三上悠亚是那种难得一见的演员——天赋与努力兼具。在《东京恋物语》的拍摄中，她对角色的理解和投入程度让我印象深刻。每一个细微的表情变化，她都能精准把握。她注定会在演艺道路上越走越远。',
    rating: 5,
  },
  {
    id: 2,
    name: '小林伸一郎',
    role: '著名摄影师',
    content: '与她合作拍摄写真集是一次非常愉快的经历。三上悠亚在镜头前的表现力极强，她有一种独特的魅力，能够将平凡的场景变得生动而富有故事感。她的专业态度也令人钦佩，每次拍摄都全力以赴。',
    rating: 5,
  },
  {
    id: 3,
    name: '山田由美',
    role: '知名编剧',
    content: '为三上悠亚量身打造剧本角色是一件充满乐趣的事情。她能够将文字中的人物活灵活现地呈现出来，甚至赋予角色超越剧本本身的深度。她的成长速度令人惊讶，每一部作品都在进步。',
    rating: 5,
  },
  {
    id: 4,
    name: '龟田诚治',
    role: '音乐制作人',
    content: '三上悠亚的嗓音有一种天然的温暖感，非常适合抒情歌曲。在录制《雪之华》时，她对情感的把控让我非常惊喜。她不是专业歌手出身，但她的努力和天赋让最终的作品超越了预期。',
    rating: 5,
  },
  {
    id: 5,
    name: '中村优子',
    role: 'VOCE杂志主编',
    content: '三上悠亚是我们杂志最受欢迎的封面人物之一。她不仅拥有令人称羡的外表，更有着独特的时尚品味和个人风格。每次合作，她都能为我们的读者带来新的灵感和惊喜。',
    rating: 5,
  },
  {
    id: 6,
    name: '佐藤健太',
    role: '粉丝代表',
    content: '关注三上悠亚已经八年了，从她偶像团体时期到现在，一路见证了她的成长和蜕变。最打动我的是她始终如一的真诚和努力。她不只是偶像，更像是陪伴我们成长的朋友。希望她能一直快乐地做自己想做的事。',
    rating: 5,
  },
];

export const aboutStats = [
  { label: '出道年限', value: '15年' },
  { label: '影视作品', value: '80+' },
  { label: '杂志封面', value: '120+' },
  { label: '社交媒体粉丝', value: '1000万+' },
  { label: '音乐作品', value: '15首' },
  { label: '慈善捐款', value: '5000万+' },
];